import * as types from '../constants/adminConstants';

const initialState = {
  addressUpdate: {
    details: {
      oldAddress: {},
      newAddress: {},
      changedFields: []
    },
    loading: false,
    actioned: false,
    error: null
  }
};

export default function Admin(state = initialState, action) {
  switch (action.type) {
    case types.GET_ADDRESS_UPDATE_DETAILS:
      return Object.assign({}, state, { addressUpdate: { ...state.addressUpdate, loading: true } });
    case types.GET_ADDRESS_UPDATE_DETAILS_SUCCESS:
      return Object.assign({}, state, { addressUpdate: { ...state.addressUpdate, details: action.response, loading: false } });
    case types.GET_ADDRESS_UPDATE_DETAILS_FAILURE:
      return Object.assign({}, state, { addressUpdate: { ...state.addressUpdate, error: action.error, details: {}, loading: false } });
    case types.APPROVE_ADDRESS:
      return Object.assign({}, state, { addressUpdate: { ...state.addressUpdate, loading: true } });
    case types.APPROVE_ADDRESS_SUCCESS:
      return Object.assign({}, state, { addressUpdate: { ...state.addressUpdate, actioned: true, loading: false } });
    case types.APPROVE_ADDRESS_FAILURE:
      return Object.assign({}, state, { addressUpdate: { ...state.addressUpdate, error: action.error, loading: false } });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/admin/reducers/admin.js